module.exports = __webpack_public_path__ + "media/PrjMgr.1c42e428.jpg";